import { useBoundStore } from '@Store/useBoundStore.ts';
import { OnboardingFlowIdentifier } from '@Types/onboarding.types.ts';
import { identifyLogRocketUser } from '@Services/analytics/logrocket.service';
import {
  AuthorizedUserType,
  InviteStatus,
} from '@Store/slices/authOnboarding/authOnboarding.types';
import type { ValidateInviteResponse } from '@Pages/accountantPortalOnboarding/api/accountantPortal.api';

export const handleAccountantPortalFlowInit = (authorizedUserId: string) => {
  const setOnboardingIdentifier = useBoundStore.getState().onboardingSlice.setOnboardingIdentifier;

  useBoundStore.getState().setAuthOnboardingData({
    customerId: '',
    customerFirstName: '',
    customerLastName: '',
    authorizedUserFullName: '',
    customerBusinessName: '',
    inviteStatus: InviteStatus.ACTIVE,
    authorizedUserType: AuthorizedUserType.ACCOUNTANT,
    authorizedUserId,
  });

  setOnboardingIdentifier(OnboardingFlowIdentifier.AUTHORIZED_USER_ACCOUNTANT_PORTAL);
  identifyLogRocketUser(authorizedUserId, {
    authorizedUserType: AuthorizedUserType.ACCOUNTANT,
  });
};

export const populateAccountantPortalData = (
  authorizedUserId: string,
  data: ValidateInviteResponse
) => {
  const setAuthOnboardingData = useBoundStore.getState().setAuthOnboardingData;

  setAuthOnboardingData({
    customerId: '',
    customerFirstName: data.firstName,
    customerLastName: data.lastName,
    authorizedUserFullName: `${data.firstName} ${data.lastName}`,
    customerBusinessName: data.firmName,
    inviteStatus: data.invitationStatus as InviteStatus,
    authorizedUserType: AuthorizedUserType.ACCOUNTANT,
    authorizedUserId,
    accountantEmail: data.email,
    accountantName: `${data.firstName} ${data.lastName}`,
    isExistingUser: data.isExistingUser,
    onboardingType: data.onboardingType,
    accountantPermissionLevel: data.accountantPermissionLevel,
  });

  if (data.phoneNumber) {
    const customerDataToUpdate = useBoundStore.getState().getCustomerData();
    customerDataToUpdate.customerData.phoneNumber = data.phoneNumber;
    useBoundStore.getState().setCustomerData(customerDataToUpdate);
  }
};
